/**
 * Vuex Store Declarations
 */
import Vue from 'vue'
import Vuex from 'vuex'
import state from './state'
import actions from './actions'
import user from './modules/user'
import mutations from './mutations'
import shared from './modules/shared'
import profile from './modules/profile'
import company from './modules/company'
import warRoom from './modules/war-room'
import activity from './modules/activity'
import projects from './modules/projects'
import portfolios from './modules/portfolios'
import pipeline from './modules/deal-pipeline'
import pnlImporter from './modules/pnl-importer'
import opexImporter from './modules/opex-importer'
import debtServicing from './modules/debt-servicing'
import rentRollImporter from './modules/rent-roll-importer'
import rentalIncomeImporter from './modules/rental-income-importer'
import dom from './modules/dom'
import importer from './modules/importer'
import domAlt from './modules/dom-alt'
import comps from './modules/comps'

/**
 * Vue Store Plugins
 */
Vue.use(Vuex)

/**
 * Base Vuex Store Declaration
 */
export default new Vuex.Store({
    state,
    actions,
    mutations,
    modules: {
        user,
        comps,
        shared,
        warRoom,
        company,
        profile,
        activity,
        pipeline,
        projects,
        importer,
        portfolios,
        pnlImporter,
        opexImporter,
        debtServicing,
        rentRollImporter,
        rentalIncomeImporter,
        dom,
        domAlt
    }
})



// WEBPACK FOOTER //
// ./src/state/store.js